export const getFormSteps = form => {
  var _form$steps;
  const steps = form == null || (_form$steps = form.steps) == null ? void 0 : _form$steps.filter(step => {
    var _step$layout;
    return !step.hidden && ((_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null || (_step$layout = _step$layout.items) == null ? void 0 : _step$layout.length);
  }).map(step => ({
    id: step.id,
    name: step.name
  }));
  return steps;
};
//# sourceMappingURL=get-form-steps.js.map